import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { CustomDatePickerWrapper, InputControls } from '../../components';
import { CustomFormItem } from '../../../custom_shared/components';
import { InputModel } from '../../models';
import { InputWithMeta } from '../../componentTypes';

// Please note that this is a generic component if behavior for your input is different - create a new independent component (like BusinessTypeInput.tsx etc.)

interface Props {
    label: string;
    input: InputModel;
    message?: string;
}

const GenericDatePicker: InputWithMeta<Props> = ({ label, input, message }) => {
    return (
        <CustomFormItem name={input.guid} required={input.required} message={message} isReadOnly={input.isReadOnly}>
            <CustomDatePickerWrapper input={input} label={label} topRightNode={<InputControls input={input} />} />
        </CustomFormItem>
    );
};

GenericDatePicker.meta = {
    inputType: InputModel.name
};

export default observer(GenericDatePicker);
